export default class TableHeaderModel {
  constructor(id, label, minWidth, align, type = 'default') {
    this.id = id;
    this.label = label;
    this.minWidth = minWidth;
    this.align = align;
    this.type = type;
  }
}
